import { Field, useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import Label from "../../label/label";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';

interface ButtonConfigEditStepProps {
    onBack: (event: any) => void | undefined;
    onNext: (event: any) => void | undefined;
}
const ButtonConfigEditStep: FC<ButtonConfigEditStepProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const { errors, values, setFieldValue, isValid, validateForm } = useFormikContext<any>();
    const [enableNext, setEnableNext] = useState<boolean>(false);

    useEffect(() => {
        setEnableNext(values.type && values.buttonText);
    }, [values, isValid])

    return <WizardStepLayout onNext={(e) => { enableNext && onNext({ ...e, type: values.type, buttonText: values.buttonText }) }} nextDisabled={!enableNext}>
        <div className="flex flex-row pt-2">
                <div className="flex flex-col flex-1">
                    <div className="flex flex-row justify-between">
                        <Label
                            htmlFor="buttonName"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.buttonText)}:</Label>
                
                    </div>
                    <Field
                        type="text"
                        name="buttonText"
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    />
                </div>
            </div>
    </WizardStepLayout>
}

export default ButtonConfigEditStep;